import {IExactGlobeConfiguration} from './erp-exactGlobe';
import {IExactOnlineConfiguration} from './erp-exactOnline';
import {ISapConfiguration} from './erp-sap';

export interface IErp {
  exactGlobeConfiguration: IExactGlobeConfiguration;
  exactOnlineConfiguration: IExactOnlineConfiguration;
  sapConfiguration: ISapConfiguration;
  type: Type;
}

export type Type = 'NONE' | 'SAP' | 'EXACT_ONLINE' | 'EXACT_GLOBE';
export const TypeValues: Type[] = ['NONE' , 'SAP' , 'EXACT_ONLINE' , 'EXACT_GLOBE'];

